/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturInstallIcon32Regular = forwardRef('KonturInstallIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M18.198 16.784a2.333 2.333 0 1 0-1.414 1.414l4.509 4.51a1 1 0 0 0 1.414-1.415l-4.509-4.509Z" }),
        React.createElement("path", { d: "M15 8a1 1 0 0 1 1-1 9.067 9.067 0 0 1 7.116 3.49 9.067 9.067 0 0 1 1.598 7.762 1 1 0 0 1-1.937-.5 7.052 7.052 0 0 0-1.242-6.038A7.052 7.052 0 0 0 16 9a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3ZM5 16C5 9.925 9.925 5 16 5s11 4.925 11 11-4.925 11-11 11S5 22.075 5 16Z" })));
});
